import React, {
  ReactNode,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

import { isPhone } from '../../../services/device';

export const TOAST_DURATION = 4000;

export const LayoutContext = createContext<{
  isDrawerOpen: boolean;
  toggleDrawer: () => void;
}>({
  isDrawerOpen: false,
  toggleDrawer: () => {},
});

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error(
      'useLayoutContext must be used within a LayoutContextProvider',
    );
  }

  return context;
};

export const LayoutContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(!isPhone);

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  const contextLayout = useMemo(
    () => ({ isDrawerOpen, toggleDrawer }),
    [isDrawerOpen, toggleDrawer],
  );

  return (
    <LayoutContext.Provider value={contextLayout}>
      {children}
    </LayoutContext.Provider>
  );
};
